<template>
    <el-container>
        <el-header style="height: 30px">
            <el-form :inline="true" :model="inteboTeam">
                <el-form-item label="月份">
                    <el-date-picker v-model="param.month" type="month" size="mini" placeholder="选择月" value-format="yyyy-MM"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="openAdd" size="mini">新增</el-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-main>
            <el-descriptions direction="vertical" :column="1" border v-for="(item,idx) in inteboTeamData" :key="idx" style="margin-bottom: 20px">
                <template slot="extra">
                    <el-button @click="deleteInteboTeamById(item.inteboTeam.id)" type="text" size="small" style="color: red">删除</el-button>
                </template>
                <el-descriptions-item label="团队领导">{{item.inteboTeam.teamleadername}}</el-descriptions-item>
                <el-descriptions-item label="团队成员">
                    <span v-for="(val,index) in item.inteboTeamMembers" :key="index">{{val.staffname}},</span>
                </el-descriptions-item>
            </el-descriptions>
        </el-main>
        <el-dialog title="新增团队信息" :visible.sync="dialogVisible" width="100%" top="0px">
            <el-form ref="form" :model="addinteboTeam" label-width="80px" :rules="rules" size="mini">
                <el-form-item label="月份" prop="mth">
                    <el-date-picker v-model="addinteboTeam.mth" type="month" size="mini" placeholder="选择月" value-format="yyyy-MM" @change="monthChange"></el-date-picker>
                </el-form-item>
                <el-form-item label="团队领导" prop="teamleader">
                    <el-select v-model="addinteboTeam.teamleader" placeholder="请选择" style="width: 100%" filterable default-first-option clearable>
                        <el-option v-for="(item,key) in staffData" :value="item.staffid" :label="item.staffname" :key="key"></el-option>
                    </el-select>
                </el-form-item>
                <el-table height="350px" class="productTable" border :data="inteboTeamMemberData" size="mini" style="text-align: center" highlight-current-row :bean="inteboTeamMember">
                    <el-table-column label="团队成员"  align="center" prop="staffid">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.staffid" @keyup.enter.native="tableEnter(scope)" :ref="scope.column.property+'_'+scope.$index" placeholder="请选择" style="width: 100%" filterable default-first-option clearable>
                                <el-option v-for="(item,key) in staffData" :value="item.staffid" :label="item.staffname" :key="key"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作"  align="center" prop="operation">
                        <template slot-scope="scope">
                            <el-button @click="$addTableRow(scope)" type="text" size="small">新增</el-button>
                            <el-button @click="$deleteTableRow(scope)" type="text" size="small" style="color: red">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" :loading="queryLoadBtton" size="mini" @click="saveInteboTeam()">确定</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            rules:{
                mth: [
                    {required: true, message: "请选择月份", trigger: 'blur'},
                ],
                teamleader: [
                    {required: true, message: "请选择团队领导", trigger: 'blur'},
                ],
            },
            columnIndexs:[],
            staffData:[],
            queryLoadBtton:false,
            inteboTeamMember:{
                staffid:"",
            },
            inteboTeamData:[],
            inteboTeamMemberData:[],
            dialogVisible:false,
            param:{
                storeid:localStorage.getItem("storeid"),
                month:this.$moment().startOf('month').format('YYYY-MM'),
            },
            addinteboTeam:{},
            inteboTeam:{
                storeid:localStorage.getItem("storeid"),
                mth:this.$moment().startOf('month').format('YYYY-MM'),
                teamleader:"",
                createdate:"",
                createtor:"",
                createtorname:"",
            }
        }
    },
    created() {
        this.getInteboStaffByParam();
        this.getInteboTeamByMonth();
    },
    methods:{
        monthChange(val){
            this.getInteboTeamByMonth();
        },
        deleteInteboTeamById(id){
            this.$dialog.confirm({
                title: '删除',
                message: "您确定要删除该团队信息吗",
            }).then(() => {
                this.$post("inteboStaff/deleteInteboTeamById",{id:id}).then(res=>{
                    if(res.sucess){
                        this.$message({message: "删除成功", type: 'success'});
                        this.getInteboTeamByMonth();
                    }
                });
            });
        },
        getInteboTeamByMonth(){
            this.$post("inteboStaff/getInteboTeamByMonth",{storeid:this.param.storeid,mth:this.param.month}).then(res=>{
                if(res.sucess){
                    this.inteboTeamData=res.object;
                }
            });
        },
        saveInteboTeam() {
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    this.addinteboTeam.createtor=localStorage.getItem("staffid");
                    this.addinteboTeam.createtorname=localStorage.getItem("staffname");
                    let inteboTeamMembers=[];
                    if(this.inteboTeamMemberData!=null && this.inteboTeamMemberData.length>0){
                        for(let val of this.inteboTeamMemberData){
                            if(val.staffid){
                                inteboTeamMembers.push(val);
                            }
                        }
                    }

                    if(inteboTeamMembers.length<1){
                        this.$message({message: "请输入团队成员", type: 'error'});
                        return;
                    }
                    let inteboTeamVo={};
                    inteboTeamVo.inteboTeam=this.addinteboTeam;
                    inteboTeamVo.inteboTeamMembers=inteboTeamMembers;
                    this.queryLoadBtton=true;
                    this.$postw("inteboStaff/saveInteboTeam",inteboTeamVo).then(res=>{
                        this.queryLoadBtton=false;
                        if(res.sucess){
                            this.$message({message: "保存成功", type: 'success'});
                            this.dialogVisible=false;
                            this.getInteboTeamByMonth();
                        }
                    });
                }
            });

        },
        openAdd(){
            this.addinteboTeam=this.$copy(this.inteboTeam);
            this.inteboTeamMemberData=[];
            this.dialogVisible=true;
            this.inteboTeamMemberData.push(this.$copy(this.inteboTeamMember));
        },
        getInteboStaffByParam(){
            this.$post("inteboStaff/getInteboStaffByType",{type:1}).then(res=>{
                if(res.sucess){
                    this.staffData=res.object;
                }
            });
        },
        tableEnter(scope) {
            var column = scope.store.states.columns;
            var length = column.length;
            if (this.columnIndexs.length < 1) {
                if (column != null && column.length > 0) {
                    for (var i = 0; i < column.length; i++) {
                        this.columnIndexs[column[i].property] = i;
                    }
                }
            }
            var conname = scope.column.property + "_" + scope.$index;
            var curCon = this.$refs[conname];
            console.log(curCon.$options._componentTag);
            if(curCon.$options._componentTag=="el-select"){
                curCon.blur();
            }
            if( curCon.$options._componentTag=="el-date-picker") {
                curCon.hidePicker();
            }
            console.log(curCon);
            var index = this.columnIndexs[scope.column.property];
            while (index <= length - 1) {
                if (index == column.length - 1) {
                    if ((scope.store.table.$options.propsData.data.length - 1) == scope.$index) {
                        scope.store.table.$options.propsData.data.push(this.$copy(scope.store.table.$attrs.bean));
                        //this.rooms.push(this.$copy(this.room));
                        this.$nextTick(function () {
                            conname = column[0].property+"_" + (scope.$index + 1);
                            var con = this.$refs[conname];
                            con.focus();
                            con.$children[0].select();
                        });
                    }
                    else {
                        conname = column[0].property+"_" + (scope.$index + 1);
                        var con = this.$refs[conname];
                        con.focus();
                        con.select();
                    }
                }
                else {
                    var property = scope.store.states.columns[index + 1].property;
                    conname = property + "_" + scope.$index;
                    var con = this.$refs[conname];
                    if (con != undefined) {
                        if (con.disabled == false) {
                            con.focus();
                            con.$children[0].select();
                            break;
                        }
                    }
                }
                index++
            }
        }
    }
}
</script>
<style lang="scss" rel="stylesheet/scss">
.productTable {
    .el-button{
        padding: 0px;
    }
    &.el-table--enable-row-hover {
        /*.el-table__body {
            tr{
                &:hover{
                    &>td{
                        background-color:transparent;
                    }
                }
            }
        }*/
    }
    .el-table__row {
        td {
            padding: 0;
            .cell {
                padding: 0 !important;
                .el-input {
                    input {
                        font-size: .7rem;
                        text-align: initial;
                        background-color: transparent;
                        border: 1px solid transparent;
                        height: 1rem;
                        padding: 1rem .5rem;
                        border-radius: 0;
                        &:focus {
                            border-color: #409eff;
                            background-color: #fff;
                        }
                        &[disabled] {
                            background-color: #fbfbfb;
                        }
                    }
                }
                .el-select {
                    .el-input {
                        &.is-disabled {
                            .el-input__inner {
                                &:hover {
                                    border-color: transparent;
                                }
                            }
                        }
                    }
                }
                .el-date-editor {
                    &.el-input {
                        width: auto;
                    }
                    .el-input__prefix {
                        right: 0;
                        left: inherit;
                        .el-input__icon {
                            line-height: 1;
                            opacity: .2;
                        }
                    }
                    .el-input__suffix {
                        .el-icon-circle-close {
                            display: none;
                        }
                    }
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/page/intebo/intebostaff/inteboteam.vue